/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable react/prop-types */
import React from 'react';
import { Modal, Form, Input, Select, Upload, Button, Row, Col, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { TextArea } = Input;

function UploadModal({
  visible,
  onCancel,
  onFinish,
  form,
  fileList,
  setFileList,
  categories,
  loading
}) {
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    const isPDF = file.type === 'application/pdf';
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isImage && !isPDF) {
      message.error('You can only upload Image or PDF files!');
      return Upload.LIST_IGNORE;
    }

    if (!isLt5M) {
      message.error('File must be smaller than 5MB!');
      return Upload.LIST_IGNORE;
    }

    return false;
  };

  return (
    <Modal
      title="Upload Document"
      open={visible}
      centered
      width={700}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      bodyStyle={{ padding: '24px 12px' }}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="horizontal"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        size="middle"
        className="px-4"
      >
        <Row gutter={[16, 8]}>
          <Col span={24}>
            <Form.Item
              name="title"
              label="Title"
              rules={[{ required: true, message: 'Please enter document title' }]}
            >
              <Input placeholder="Enter document title" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="description"
              label="Description"
              rules={[{ required: true, message: 'Please enter document description' }]}
            >
              <TextArea
                placeholder="Enter document description"
                rows={2}
                style={{ resize: 'none' }}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="category_id"
              label="Category"
              rules={[{ required: true, message: 'Please select a category' }]}
            >
              <Select placeholder="Select category">
                {categories.map(category => (
                  <Select.Option key={category.id} value={category.id}>
                    {category.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="File"
              rules={[{ required: true, message: 'Please upload a file' }]}
              extra="Only Image and PDF files are allowed (max 5MB)"
            >
              <Upload
                fileList={fileList}
                onChange={({ fileList: newFileList }) => setFileList(newFileList)}
                beforeUpload={beforeUpload}
                maxCount={1}
                accept=".jpg,.jpeg,.png,.gif,.pdf"
              >
                <Button icon={<UploadOutlined />}>Select File</Button>
              </Upload>
            </Form.Item>
          </Col>

          <Col span={24} className="flex justify-end">
            <Form.Item wrapperCol={{ offset: 4, span: 20 }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Upload
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default UploadModal; 